import React from 'react';
import { Link } from 'react-scroll';
import * as Icon from 'react-feather';
import {
    NavbarBrand,
    NavbarToggler,
    NavItem,
    Nav,
    Collapse
} from "reactstrap";
import { getPayloadMedia } from '../services/payloadService';

// Import Logo (fallback)
import logodark from "../assets/images/logo-dark.png";
import logolight from "../assets/images/logo-light.png";

export default function Navbar({ landingPage, configuracion, isMenuOpen, toggleMenu }) {    
    return (
        <>
            <nav id="navbar" className="navbar navbar-expand-lg nav-light fixed-top sticky">
                <div className="container">
                    <NavbarBrand className="navbar-brand" href="/">
                        <span className="logo-light-mode">
                            <img
                                src={getPayloadMedia(configuracion?.logoPrincipal?.url) || logodark}
                                className="l-dark"
                                alt={configuracion?.nombreSitio || 'Logo'}
                                style={{maxHeight: '50px', width: 'auto'}}
                            />
                             <img
                                src={getPayloadMedia(configuracion?.logoSecundario?.url) || logodark}
                                className="l-dark"
                                alt={configuracion?.nombreSitio || 'Logo'}
                                style={{maxHeight: '20px', width: 'auto', paddingLeft: '10px'}}
                            />
                            <img
                                src={getPayloadMedia(configuracion?.logoPrincipalWhite?.url) || logolight}
                                className="l-light"
                                alt={configuracion?.nombreSitio || 'Logo'}
                                style={{maxHeight: '50px', width: 'auto'}}
                            />
                               <img
                            src={getPayloadMedia(configuracion?.logoSecundarioWhite?.url) || logolight}
                            className="l-light"
                            alt={configuracion?.nombreSitio || 'Logo'}
                            style={{maxHeight: '20px', width: 'auto', paddingLeft: '10px'}}
                        />
                        </span>
                       
                    </NavbarBrand>
                    <NavbarToggler className="navbar-toggler" onClick={toggleMenu}>
                        <Icon.Menu />
                    </NavbarToggler>

                    <Collapse className={`navbar-collapse ${isMenuOpen === true ? 'hidden' : 'show'}`} id="navbarSupportedContent">
                        <Nav className="navbar-nav ms-auto mb-2 mb-lg-0" id="navbar-navlist">
                            {/* Generar NavItems dinámicamente desde las secciones */}
                            {landingPage?.secciones
                                ?.filter(seccion => seccion.mostrarEnMenu)
                                .map((seccion, index) => {
                                    // Usar blockType que es la propiedad correcta de Payload CMS
                                    const ancla = seccion.blockType || seccion.__component?.split('.')[1];
                                    const nombreMenu = seccion.nombreMenu || ancla;

                                    return (
                                        <NavItem key={index}>
                                            <Link
                                                activeClass="active"
                                                to={ancla}
                                                spy={true}
                                                smooth={true}
                                                duration={500}
                                                className="nav-link"
                                            >
                                                {nombreMenu}
                                            </Link>
                                        </NavItem>
                                    );
                                })}
                        </Nav>
                    </Collapse>
                </div>
            </nav>
        </>
    );
}
